export interface LocalState { localDirty: boolean; localBaseVersion: number; }
export interface ServerState { docVersion: number; }
export type ReconcileAction = { action: 'keep-local' } | { action: 'adopt-server' } | { action: 'push' };

/** Pure open-flow policy. Dirty local always pushes (a 409 is then resolved
 *  keep-mine by default). Clean local adopts the server when it is newer. */
export function decideReconcile(local: LocalState, server: ServerState): ReconcileAction {
  if (local.localDirty) return { action: 'push' };
  if (server.docVersion > local.localBaseVersion) return { action: 'adopt-server' };
  return { action: 'keep-local' };
}
